import React, { useEffect, useState } from 'react';
import { Box, FormControl, Typography } from '@mui/material';
import styles from 'app/components/AccordionCustom/AttachDetails/textarea.module.css';
import { textareaBox } from 'app/components/AccordionCustom/AttachDetails/AttachDetails.sx';
import FieldError from 'app/components/FieldError';
import { date } from 'yup';
import logger from 'app/utils/logger';

interface Props {
  errors?: any;
  register?: any;
  dataForm?: any;
  values?: any;
  maxLength?: any;
  valueTextArea?: any;
  handleChangeTextArea?: any;
}

const TextArea = (props: Props) => {
  const { errors, register, dataForm, values, maxLength, valueTextArea, handleChangeTextArea } = props;
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(valueTextArea.length);
  }, [valueTextArea]);

  // const handleChangeCount = (e: any) => {
  //   const inputValue = e.target.value;
  //   const regexForTextArea = /^[a-zA-Z0-9.~`"'?_,№:;\n -]*$/;
  //
  //   if (regexForTextArea.test(inputValue)) {
  //     setCount(inputValue.length);
  //   }
  // };

  logger.log('dataForm');
  logger.log(dataForm);

  return (
    <Box sx={textareaBox}>
      <Typography sx={{ fontSize: '15px', fontWeight: 400 }}>Ödənişin təyinatı</Typography>
      <FormControl>
        <Box sx={{ position: 'relative' }}>
          <textarea
            {...register('desc', {
              onChange: (e: any) => {
                // handleChangeCount(e);
                handleChangeTextArea(e);
              },
            })}
            className={
              errors?.desc !== undefined || dataForm?.error?.fields.description !== undefined
                ? `${styles.error} ${styles.textarea}`
                : styles.textarea
            }
            maxLength={maxLength}
            value={valueTextArea}
          ></textarea>
          <Typography sx={{ position: 'absolute', bottom: '12px', right: '12px', color: 'rgba(20, 25, 31, 0.56)' }}>
            {count}/{maxLength}
          </Typography>
        </Box>
        <FieldError
          error={
            errors?.desc
              ? errors?.desc
              : dataForm?.error?.fields.description && { message: dataForm?.error?.fields.description }
          }
        />
      </FormControl>
    </Box>
  );
};

export default TextArea;
